import React, { useState, useEffect, useCallback } from 'react';

const CulinaryTermsCard = ({ question, allTerms, onAnswer }) => {
  const [options, setOptions] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);

  // Shuffle array function
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Generate distractors
  const generateDistractors = useCallback((correctTerm, allTerms) => {
    const distractors = allTerms.filter(term => term.term !== correctTerm.term);
    const shuffledDistractors = shuffleArray(distractors);
    return shuffledDistractors.slice(0, 3);
  }, []);

  // Setup question when component mounts or question changes
  useEffect(() => {
    if (!question) return;

    // Reset state
    setSelectedAnswer(null);
    setIsAnswered(false);

    // Set correct answer as the definition
    setCorrectAnswer(question.definition);

    // Generate options (correct definition + 3 distractors)
    const distractors = generateDistractors(question, allTerms);
    const allOptions = [
      question.definition,
      ...distractors.map(term => term.definition)
    ];

    setOptions(shuffleArray(allOptions));
  }, [question, allTerms, generateDistractors]);

  // Handle answer selection
  const handleAnswerClick = (answer) => {
    if (isAnswered) return;

    setSelectedAnswer(answer);
    setIsAnswered(true);
    
    const isCorrect = answer === correctAnswer;
    onAnswer(isCorrect, answer, correctAnswer);
  };

  // Get button class based on state
  const getButtonClass = (option) => {
    if (!isAnswered) return 'answer-button';
    
    let classes = 'answer-button disabled';
    
    if (option === correctAnswer) {
      classes += ' correct';
    } else if (option === selectedAnswer && option !== correctAnswer) {
      classes += ' incorrect';
    }
    
    return classes;
  };

  // Generate Google search URL
  const getSearchUrl = () => {
    return `https://google.com/search?q=${encodeURIComponent(`${question.term} culinary definition`)}`;
  };

  if (!question) return null;

  return (
    <div className="question-card">
      <div className="question">
        <strong>What is the definition of:</strong>
        <br /><br />
        <div className="culinary-term">
          "{question.term}"
        </div>
        <br />
        <small className="category-hint">Category: {question.category}</small>
      </div>
      
      <div className="answers">
        {options.map((option, index) => (
          <button
            key={index}
            className={getButtonClass(option)}
            onClick={() => handleAnswerClick(option)}
            disabled={isAnswered}
          >
            {option}
          </button>
        ))}
      </div>
      
      <a 
        href={getSearchUrl()} 
        target="_blank" 
        rel="noopener noreferrer"
        className="lookup-link"
      >
        Look Up
      </a>
    </div>
  );
};

export default CulinaryTermsCard; 